import React from "react";
import Icon from "components/AppIcon";

const territories = [
  { id: 1, name: "Downtown District", faction: "Iron Wolves", profitBonus: 15, safetyBonus: 8, controlled: true },
  { id: 2, name: "Harbor Zone", faction: "Iron Wolves", profitBonus: 10, safetyBonus: 5, controlled: true },
  { id: 3, name: "Tech Quarter", faction: "Rival Faction", profitBonus: 0, safetyBonus: 0, controlled: false },
];

const TerritoryBonusPanel = ({ totalBonus = 25 }) => (
  <div className="rounded-xl p-4 md:p-5" style={{ background: "var(--color-card)", border: "1px solid var(--color-border)" }}>
    <div className="flex items-center justify-between mb-4">
      <div className="flex items-center gap-2">
        <Icon name="Map" size={16} color="var(--color-accent)" />
        <span className="font-heading text-sm font-semibold text-foreground">Territory Bonuses</span>
      </div>
      <div className="flex items-center gap-1.5 px-2 py-1 rounded" style={{ background: "rgba(255,184,0,0.12)", border: "1px solid rgba(255,184,0,0.3)" }}>
        <Icon name="TrendingUp" size={12} color="var(--color-accent)" />
        <span className="font-caption text-xs font-bold" style={{ color: "var(--color-accent)" }}>+{totalBonus}% Total</span>
      </div>
    </div>
    <div className="space-y-2">
      {territories?.map((t) => (
        <div key={t?.id} className="flex items-center justify-between p-2.5 rounded-lg" style={{ background: t?.controlled ? "rgba(255,184,0,0.06)" : "rgba(0,0,0,0.2)", border: `1px solid ${t?.controlled ? "rgba(255,184,0,0.2)" : "rgba(255,255,255,0.05)"}` }}>
          <div className="flex items-center gap-2 min-w-0">
            <Icon name={t?.controlled ? "CheckCircle" : "XCircle"} size={13} color={t?.controlled ? "var(--color-success)" : "var(--color-muted-foreground)"} />
            <div className="min-w-0">
              <div className="font-caption text-xs text-foreground truncate">{t?.name}</div>
              <div className="font-caption text-xs text-muted-foreground truncate">{t?.faction}</div>
            </div>
          </div>
          {t?.controlled ? (
            <div className="flex gap-2 flex-shrink-0">
              <span className="font-caption text-xs" style={{ color: "var(--color-accent)" }}>+{t?.profitBonus}%</span>
              <span className="font-caption text-xs" style={{ color: "var(--color-success)" }}>+{t?.safetyBonus}% safe</span>
            </div>
          ) : (
            <span className="font-caption text-xs text-muted-foreground">Hostile</span>
          )}
        </div>
      ))}
    </div>
  </div>
);

export default TerritoryBonusPanel;